var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"imageViewer",attrs:{"hide-footer":"","size":"xl","id":"image-viewers","modal-class":"viewer-class"}},[_c('b-img',{staticClass:"shown-image",attrs:{"fluid":"","src":_vm.imageUrl,"alt":"ImageViewer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }